/**
 * Created by fky on 02/23/2017.
 */
'use strict';

angular.module('betosyswebapp')
  .controller('DeleteCtrl', function ($scope, $uibModalInstance,selectedRowData,telephoneService,errorHandlingService) {
    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };
    $scope.onKeyPress = function ($event) {
      if ($event.keyCode === 13) {
        $scope.delete();
      }
    };
     $scope.delete = function () {
       var telephoneDetail = {
         key: selectedRowData.key,
         name: selectedRowData.name,
         telephoneNumber: selectedRowData.telephoneNumber
       };
       telephoneService.deleteTelephone(telephoneDetail).then(function () {
         $uibModalInstance.close('success');
       },function(response) {
         $uibModalInstance.close('error');
         errorHandlingService.handleForCommonResponse(response);
       });
     };
  });



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/deleteController.js